import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiFaqsGet } from '@/entities/faq/modules/api/faqs';

export const useFaqs = () =>
  useFetch({
    api: apiFaqsGet,
    keywords: queryKeys.faqs.all,
    staleTime: 5 * 60 * 1000,
  });
